import { useLanguage } from "../contexts/LanguageContext";
import "../styles/About.css"

const About = () => {
    const { language } = useLanguage();

    const aboutContent = {
        brand: {
            english: "About Us",
            tamil: "எங்களைப் பற்றி"
        },
        brandes: {
            english: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum",
            tamil: "லோரெம் இப்சம் என்பது அச்சிடுதல் மற்றும் தட்டச்சு அமைப்புத் துறையின் போலி உரை மட்டுமே. 1500களில் இருந்து, தெரியாத ஒரு அச்சுப்பொறி ஒரு தட்டச்சு மாதிரி புத்தகத்தை உருவாக்க அதைத் துடைத்ததிலிருந்து லோரெம் இப்சம் தொழில்துறையின் நிலையான போலி உரையாக இருந்து வருகிறது. இது ஐந்து நூற்றாண்டுகள் மட்டுமல்ல, மின்னணு தட்டச்சு அமைப்பிலும் பாய்ந்து, அடிப்படையில் மாறாமல் உள்ளது. இது 1960களில் லோரெம் இப்சம் பத்திகளைக் கொண்ட லெட்ராசெட் தாள்களின் வெளியீட்டிலும், சமீபத்தில் லோரெம் இப்சமின் பதிப்புகள் உட்பட ஆல்டஸ் பேஜ்மேக்கர் போன்ற டெஸ்க்டாப் வெளியீட்டு மென்பொருளிலும் பிரபலமடைந்தது."
        }
    }
    return (
        <div id='about'>
            <section className="about">
                <div className="about-container">
                    <div className="about-left">
                        <img src="/assets/tvkimages/image 8.png" className="aboutimg1" alt="" />
                        <img src="/assets/tvkimages/heroimg2.png" className="aboutimg2" alt="" />
                        <div className='numbers'>
                            <h1>50,00,000+ <br />MEMBERS</h1>
                            <h1>30,000+ <br />VOLUNTEERS</h1>
                        </div>
                    </div>

                    <div className="about-right">
                        <h1>{aboutContent.brand[language]}</h1>
                        <p>{aboutContent.brandes[language]}</p>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default About